'use client';

import { useState, useCallback } from 'react';
import GalleryHero from './GalleryHero';
import GalleryGrid from './GalleryGrid';
import GalleryLightbox from './GalleryLightbox';

export interface GalleryImage {
  id: number;
  src: string;
  alt: string;
  category: 'Common Areas' | 'Exterior' | 'Luxos' | 'Primera' | 'Classica';
  span?: 'normal' | 'wide' | 'tall';
}

const allImages: GalleryImage[] = [
  {
    id: 1,
    src: '/assets/images/IMG20251021172031-1782648149088.jpg',
    alt: 'Primera Lobby',
    category: 'Common Areas',
    span: 'tall',
  },
  {
    id: 2,
    src: '/assets/images/IMG20251021172108-1782648149023.jpg',
    alt: 'Primera Lobby',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 3,
    src: '/assets/images/IMG20251021172147_copy-1782648149125.jpg',
    alt: 'Primera Lobby',
    category: 'Common Areas',
    span: 'wide',
  },
  {
    id: 4,
    src: '/assets/images/IMG20251021172208-1782648149063.jpg',
    alt: 'Primera Lobby',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 5,
    src: '/assets/images/IMG202510211726519-1782648149106.jpg',
    alt: 'Primera Lobby',
    category: 'Common Areas',
    span: 'tall',
  },
  {
    id: 6,
    src: '/assets/images/IMG20251021170956-1782648317338.jpg',
    alt: 'Luxos Lobby',
    category: 'Common Areas',
    span: 'tall',
  },
  {
    id: 7,
    src: '/assets/images/IMG20251021171023-1782648317373.jpg',
    alt: 'Luxos Lobby',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 8,
    src: '/assets/images/IMG20251021171047-1782648317373.jpg',
    alt: 'Luxos Lobby',
    category: 'Common Areas',
    span: 'wide',
  },
  {
    id: 9,
    src: '/assets/images/IMG20251021171107-1782648317427.jpg',
    alt: 'Luxos Lobby',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 10,
    src: '/assets/images/IMG20251021172659-1782648317342.jpg',
    alt: 'Luxos Lobby',
    category: 'Common Areas',
    span: 'tall',
  },
  {
    id: 11,
    src: '/assets/images/IMG20251029135104-1782648876696.jpg',
    alt: 'Classica Lobby',
    category: 'Common Areas',
    span: 'tall',
  },
  {
    id: 12,
    src: '/assets/images/IMG20251029140614-1782648876656.jpg',
    alt: 'Classica Lobby',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 13,
    src: '/assets/images/IMG20251029140810-1782648876714.jpg',
    alt: 'Classica Lobby',
    category: 'Common Areas',
    span: 'wide',
  },
  {
    id: 14,
    src: '/assets/images/IMG20251029141114-1782648876682.jpg',
    alt: 'Classica Lobby',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 15,
    src: '/assets/images/IMG20251021172031-1782648149088.jpg',
    alt: 'Primera Lobby',
    category: 'Primera',
    span: 'tall',
  },
  {
    id: 16,
    src: '/assets/images/IMG20251021172108-1782648149023.jpg',
    alt: 'Primera Lobby',
    category: 'Primera',
    span: 'normal',
  },
  {
    id: 17,
    src: '/assets/images/IMG20251021172147_copy-1782648149125.jpg',
    alt: 'Primera Lobby',
    category: 'Primera',
    span: 'wide',
  },
  {
    id: 18,
    src: '/assets/images/IMG20251021172208-1782648149063.jpg',
    alt: 'Primera Lobby',
    category: 'Primera',
    span: 'normal',
  },
  {
    id: 19,
    src: '/assets/images/IMG202510211726519-1782648149106.jpg',
    alt: 'Primera Lobby',
    category: 'Primera',
    span: 'tall',
  },
  {
    id: 20,
    src: '/assets/images/IMG20251021170956-1782648317338.jpg',
    alt: 'Luxos Lobby',
    category: 'Luxos',
    span: 'tall',
  },
  {
    id: 21,
    src: '/assets/images/IMG20251021171023-1782648317373.jpg',
    alt: 'Luxos Lobby',
    category: 'Luxos',
    span: 'normal',
  },
  {
    id: 22,
    src: '/assets/images/IMG20251021171047-1782648317373.jpg',
    alt: 'Luxos Lobby',
    category: 'Luxos',
    span: 'wide',
  },
  {
    id: 23,
    src: '/assets/images/IMG20251021171107-1782648317427.jpg',
    alt: 'Luxos Lobby',
    category: 'Luxos',
    span: 'normal',
  },
  {
    id: 24,
    src: '/assets/images/IMG20251021172659-1782648317342.jpg',
    alt: 'Luxos Lobby',
    category: 'Luxos',
    span: 'tall',
  },
  {
    id: 25,
    src: '/assets/images/IMG20251029135104-1782648876696.jpg',
    alt: 'Classica Lobby',
    category: 'Classica',
    span: 'tall',
  },
  {
    id: 26,
    src: '/assets/images/IMG20251029140614-1782648876656.jpg',
    alt: 'Classica Lobby',
    category: 'Classica',
    span: 'normal',
  },
  {
    id: 27,
    src: '/assets/images/IMG20251029140810-1782648876714.jpg',
    alt: 'Classica Lobby',
    category: 'Classica',
    span: 'wide',
  },
  {
    id: 28,
    src: '/assets/images/IMG20251029141114-1782648876682.jpg',
    alt: 'Classica Lobby',
    category: 'Classica',
    span: 'normal',
  },
  {
    id: 29,
    src: '/assets/images/Reception1-1782649835522.jpg',
    alt: 'Front Desk',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 30,
    src: '/assets/images/WhatsApp_Image_2025-06-09_at_17.19.42_cf2e29ac-1782649892057.jpg',
    alt: 'Visitor Lounge',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 31,
    src: '/assets/images/WhatsApp_Image_2025-06-24_at_11.14.26_bcf75d40-1782649966103.jpg',
    alt: 'Elevator Lobby',
    category: 'Common Areas',
    span: 'normal',
  },
  {
    id: 32,
    src: '/assets/images/IMG20251018144536_copy-1782650117724.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'normal',
  },
  {
    id: 33,
    src: '/assets/images/IMG20251018144719_copy-1782650117738.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'wide',
  },
  {
    id: 34,
    src: '/assets/images/IMG20251018150955_copy-1782650117691.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'tall',
  },
  {
    id: 35,
    src: '/assets/images/IMG20251018151027_copy-1782650117737.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'normal',
  },
  {
    id: 36,
    src: '/assets/images/IMG20251018151720_copy-1782650117660.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'wide',
  },
  {
    id: 37,
    src: '/assets/images/IMG20251018152237_copy-1782650395067.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'normal',
  },
  {
    id: 38,
    src: '/assets/images/IMG20251018152338_copy-1782650395052.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'wide',
  },
  {
    id: 39,
    src: '/assets/images/IMG20251018154041_copy-1782650437253.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'tall',
  },
  {
    id: 40,
    src: '/assets/images/IMG20251018154230_copy-1782650437214.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'normal',
  },
  {
    id: 41,
    src: '/assets/images/IMG20251018155128_copy-1782650437280.jpg',
    alt: 'Primera',
    category: 'Primera',
    span: 'wide',
  },
];

export type FilterCategory = 'All' | 'Classica' | 'Common Areas' | 'Exterior' | 'Luxos' | 'Primera';

export default function GalleryInteractive() {
  const [activeFilter, setActiveFilter] = useState<FilterCategory>('All');
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);

  const filteredImages = activeFilter === 'All'
    ? allImages
    : allImages.filter((img) => img.category === activeFilter);

  const openLightbox = useCallback((index: number) => {
    setLightboxIndex(index);
  }, []);

  const closeLightbox = useCallback(() => {
    setLightboxIndex(null);
  }, []);

  const goNext = useCallback(() => {
    if (lightboxIndex === null) return;
    setLightboxIndex((lightboxIndex + 1) % filteredImages.length);
  }, [lightboxIndex, filteredImages.length]);

  const goPrev = useCallback(() => {
    if (lightboxIndex === null) return;
    setLightboxIndex((lightboxIndex - 1 + filteredImages.length) % filteredImages.length);
  }, [lightboxIndex, filteredImages.length]);

  return (
    <div className="min-h-screen bg-background">
      <GalleryHero />
      <GalleryGrid
        images={filteredImages}
        activeFilter={activeFilter}
        onFilterChange={setActiveFilter}
        onImageClick={openLightbox}
      />
      {lightboxIndex !== null && (
        <GalleryLightbox
          images={filteredImages}
          currentIndex={lightboxIndex}
          onClose={closeLightbox}
          onNext={goNext}
          onPrev={goPrev}
        />
      )}
    </div>
  );
}
